<template>
  <div class="container">
      <div id="header" class="header"></div>
    <div class="top-add">
      <el-carousel :interval="5000" arrow="never" height="18vw">
          <el-carousel-item v-for="item in carouselImg" :key="item">
            <img class="carouselimg" :src="item"/>
          </el-carousel-item>
      </el-carousel>
    </div>
    <div class="content">
    <div class="content-left">
        <div class="menu-card" style="display: block">
                <div class="menu-card-content">
                   <ul class="menu-show" style="padding-left:0;margin:0;">
                    <!-- style="background-color:#1d4a94;" -->
                      <li class="menu-show-title">
                       <div class="menu-addrc" :class="num2==='全部商品分类'? 'activetext':'' "  @click="getallgoods2()"><i class="el-icon-menu" style="margin-right:10px"></i>全部商品分类</div>
                      </li>
                      <div v-for="(item,index) in menuList" :key="index">
                  
                      <el-popover
                        placement="right"
                        width="260"
                        trigger="hover"
                        :visible-arrow="false"
                        popper-class="left-popover"
                      >

                        <div class="info-card" style="display: block">
                            <div class="info-card-content">
                              <ul class="info-show" style="padding-left:0;margin:0">
                                  <li class="info-popper-title">
                                  <div  :class="num2===item.sun_class? 'activetext':'' "  @click="clickPaixu('','',item.sun_class)">{{item.sun_class}}<i class="el-icon-arrow-right" style="margin-left:10px"></i></div>
                                  </li>

                                  <li class="info-show-title" v-for="(item2,index) in item.category" :key="index">


                      <el-popover
                        placement="right"
                        width="260"
                        trigger="hover"
                        :visible-arrow="false"
                        :appendToBody="false"
                        popper-class="left-popover"
                      >

                        <div class="info-card" style="display: block">
                            <div class="info-card-content">
                              <ul class="info-show" style="padding-left:0;margin:0">
                                  <li class="info-popper-title">
                                  <div  :class="num===item2.sun_type? 'activetext':'' "  @click="clickPaixu('',item2.sun_type,item.sun_class)">{{item2.sun_type}}<i class="el-icon-arrow-right" style="margin-left:10px"></i></div>
                                  </li>

                                  <li class="info-show-title" v-for="(item3,index) in item2.sorts" :key="index">
                                    
                                  <div class="title-addrc3" @click="clickPaixu(item3.sun_sort,item2.sun_type,item.sun_class)" :class="num3===item3.sun_sort? 'activetext':'' ">{{item3.sun_sort}}</div>
                                  </li>
                                </ul>         
                            </div>                         
                        </div>

                        <div class="contact" slot="reference"> <li class="menu-show-title" > <div class="title-addrc" @click="clickPaixu('',item2.sun_type,item.sun_class)" :class="num===item2.sun_type? 'activetext':'' ">{{item2.sun_type}}</div> </li></div>
                      </el-popover>


                                  <!-- <div class="title-addrc" @click="clickPaixu(item2.type,item.class)" :class="num===item2.type? 'activetext':'' ">{{item2.type}}</div> -->
                                  </li>
                                </ul>         
                            </div>                         
                        </div>

                        <div class="contact" slot="reference"> <li class="menu-show-title" > <div class="menu-addrc" @click="clickPaixu('','',item.sun_class)"  :class="num2===item.sun_class? 'activetext':'' "><i :class="item.icon" style="margin-right:10px"></i>{{item.sun_class}}</div> </li></div>
                      </el-popover>
                     </div>
                    </ul>         
                </div>                         
            </div>    
    </div>

    <div class="content-right">
        <div class="right-top">
          <div class="right-breadcrumb">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item v-show="this.num2!==''">{{num2}}</el-breadcrumb-item>
            <el-breadcrumb-item v-show="this.num!==''"> {{num}}</el-breadcrumb-item>
            <el-breadcrumb-item v-show="this.num3!==''"> {{num3}}</el-breadcrumb-item>
          </el-breadcrumb>
          </div>

          <div class="right-search">
            <el-input placeholder="请输入内容" v-model="titleinput"  class="input-with-select">
                <el-button  slot="append"  icon="el-icon-search" @click="getallgoods"></el-button>
              </el-input>
          </div>
        </div>

        <div class="right-card-list">
          <ul class="card-list" style="overflow:hidden;clear:both;">
							<!-- v-for key值 -->
							<li class="phone_item" v-for="goods in goodsList" :key="goods.id">
								<!-- <a href="#"> -->
									<!-- 图片 -->
									<div class="ph">
                    <el-image 
                      style="width: 10vw; height: 8.5vw"
                      :src="goods.img[0]?goods.img[0]:defaultImg" 
                      :preview-src-list="goods.img">
                    </el-image>
										<!-- <img  :src="goods.img[0]?goods.img[0]:defaultImg" width="160"> -->
									</div>
									<!-- 手机名字 -->
									<div class="phone_title" :title="goods.title">{{goods.title}}</div>
									<!-- 备注 -->
									<p class="desc" :title="goods.sun_desc">{{goods.sun_desc}}</p>
									<!-- 价格 -->
									<p class="price">
										<span >{{goods.price}}</span>
										<!-- <span v-show="goods.price!==null">元</span> -->
									</p>
								<!-- </a> -->
                  <p class="mobile">
                    <span > <i class="el-icon-phone-outline"></i>&nbsp;{{goods.mobile}}</span>
                  </p>
							</li>
              <li class="goods_item" v-if="this.goodsList.length==0"><div class="goods_title">暂无商品</div></li>
						</ul>

            <div class="right-pagination">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-size="pagesize"
                  layout="total, prev, pager, next, jumper"
                  :total="total"
                  background
                >
                </el-pagination>
            </div>
        </div>
    </div>
    </div>
    <div id="footer" class="footer"></div>
  </div>
</template>

<script>
import $ from 'jquery'

export default {
  name: 'WebShop',
  data () {
    return {
      carouselImg:[
      //   "https://gd-hbimg.huaban.com/d8cfb468193862ffa6b6a9bd483adf98877085b381164-CzsBLa",
      // "https://gd-hbimg.huaban.com/a186588c5e02cec09b092494064a7d5acd4942678a5c3-iqF56C_fw1200webp",
      require("../assets/1.jpg")
      // "https://img.zcool.cn/community/01164560ab6fd811013eaf70e9390f.jpg?x-oss-process=image/auto-orient,1/resize,m_lfit,w_1280,limit_1/sharpen,100"
      ],
      goodsList:[],
      menuList:[],//分类菜单
      total:0,
      currentPage:0,
      pagesize:12,
      titleinput:'',
      num:'',
      num2:'全部商品分类',
      num3:'',
      sort_desc:'',
      shop_code: 'sun_mallcargo_man',
      defaultImg:require("../assets/defaultImg.png"),
    }
  },
  mounted(){
  this.getHf();
  this.getmenulist();
  this.getallgoods();
  },
  methods:{
     getHf(){
      $(".header").load("./header.html");
          $(".footer").load("./footer.html");
          $("head").append("<link>");   
            var toolbarCss = $("head").children(":last");
            toolbarCss.attr({
                rel: "stylesheet",
                type: "text/css",
                href:  "/fore/css/sunbidv5.css"
            });
    },
    unique1(arr) {
    const res = new Map();
    return arr.filter((arr) => !res.has(arr.sun_class) && res.set(arr.sun_class, arr.sun_class))
    },
    unique2(arr) {
    const res = new Map();
    return arr.filter((arr) => !res.has(arr.sun_type) && res.set(arr.sun_type, arr.sun_type))
    },
    unique3(arr) {
    const res = new Map();
    return arr.filter((arr) => !res.has(arr.sun_sort) && res.set(arr.sun_sort, arr.sun_sort))
    },

    getmenulist(){
      let url = '/hub2a.php?act=sun_mallcat_list';
            this.$http.post(url,{headers: {'Content-Type': 'application/json'}}).then(({data:res})=> {
                  // console.log('res',res);
                if (res.status == 1) {
                    // console.log('请求成功'); 
                    let menu1=res.data;
                    let menu2=this.unique1(menu1);
                    // console.log('menu2',menu2);
                    let menu3=[];
                    for(let i = 0; i < menu2.length; i++) {
                      var obj = {};  
                      obj.sun_class = menu2[i].sun_class;
                          menu3.push(obj);
                    }

                    let menu4=this.unique2(menu1);//去除重复二级菜单
                      menu4=menu4.filter(item => {
                        if (item.sun_type!==null) {
                          return item;
                        }
                      });
                  //新增二级菜单数组
                     for(let i = 0; i < menu3.length; i++) {
                          menu3[i].category = [];
                    }
                      //向二级菜单数组中push二级菜单对象
                      for(let i = 0; i < menu4.length; i++) {
                         for(let j = 0; j < menu3.length; j++) {
                          if(menu4[i].pid==menu3[j].sun_class){
                          var obj = {};  
                          obj.sun_type = menu4[i].sun_type;
                          menu3[j].category.push(obj);
                        }
                    
                         
                    }
                        
                    }
                    // console.log('menu4',menu4);

                    let menu5=this.unique3(menu1);
                     menu5=menu5.filter(item => {
                        if (item.sun_sort!==null) {
                          return item;
                        }
                      });
                    
                    for(let i = 0; i < menu3.length; i++) {
                          for(let j = 0; j < menu3[i].category.length; j++) {
                          menu3[i].category[j].sorts = [];
                    }
                    }
                    
                    for(let i = 0; i < menu5.length; i++) {
                         for(let j = 0; j < menu3.length; j++) {
                           for(let k = 0; k < menu3[j].category.length; k++) {

                            if(menu5[i].pid==menu3[j].category[k].sun_type){
                              var obj = {};  
                              obj.sun_sort = menu5[i].sun_sort;
                              menu3[j].category[k].sorts.push(obj);
                            }
                           }
                          
                    
                         
                    }
                        
                    }
                



                    // console.log('menu5',menu5);
                    // for(let i = 0; i < menu2.length; i++) {
                    //   var obj = {};  
                    //   obj.sun_class = menu2[i].sun_class;
                    //       menu3.push(obj);
                    // }



                    // console.log('menu3',menu3);
                    this.menuList=menu3;
                    // menu2=menu2.filter(item => {
                    //   // console.log('item',item);
                    //     if (item.sun_sort!==null) {
                    //       return item;
                    //     }
                    //   });
           
                              }
                              else{
                                  console.log('请求失败'); 
                              }
                          });
    },
    getallgoods(){
        // this.num='';
        // this.num3='';
        // this.num2='';
       

        let url = '/hub2a.php?act=sun_mallcargo_list';
        let formData = new FormData();
        formData.append("pagesize", this.pagesize);
        formData.append("page", this.currentPage);
        formData.append("sort_desc", this.sort_desc);
        formData.append("code", this.shop_code);
        if(this.num2=='全部商品分类'){
                  formData.append("sun_class", '');   
                }else{
                  formData.append("sun_class", this.num2);   
                }
   
        formData.append("sun_type", this.num);
        formData.append("sun_sort", this.num3);
        formData.append("title", this.titleinput);
       
          this.$http.post(url,formData,{headers: {'Content-Type': 'application/form-data'}}).then(({data:res})=> {
            //  console.log('res2',res);
             if (res.status == 1) {  
                   let goodslist2=res.data.rows;
                    this.total=res.data.count-0;

                    //图片地址处理
                    // "{\"title\":\"图片2.png\",\"value\":\"https://www.jtgs-ygcy.cn/upload/other/2023/06/15/sun-20230615-222122-3502.png\"}"
                    for(let i = 0; i < goodslist2.length; i++){
                      // let img1=goodslist[i].img.split('"');
                      let obj = JSON.parse(goodslist2[i].img);
                      //  console.log('图片地址', obj); 
                       if(obj==null){
                        goodslist2[i].img=[];
                       }else{
                        let imglist=[];
                        imglist=obj.value.split('\t');
                        // console.log('图片地址2', imglist); 
                        goodslist2[i].img=imglist;
                       }
                     // console.log('图片地址', goodslist2[i].img); 
                    }

                    this.goodsList=goodslist2;
                          }
                          else{
                                console.log('请求失败'); 
                          }
                      });

    },
    getallgoods2(){
        // this.num4='全部商品分类';
        this.num = '';
        this.num2='全部商品分类';
        this.num3='';
        this.titleinput='';
        this.getallgoods();
    },
    clickPaixu(itsort,ittype,itclass){
                // console.log("点击：" +itsort+"/"+ittype+"/"+itclass)
                // this.num4='';
                this.num = ittype;
                this.num2=itclass;
                this.num3=itsort;
                this.getallgoods();
            },
    //  handleOpen(key, keyPath) {
    //     console.log(key, keyPath);
    //   },
    //   handleClose(key, keyPath) {
    //     console.log(key, keyPath);
    //   },
       handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
        this.pagesize=val;
        this.getallgoods();
      },
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.currentPage=val;
        this.getallgoods();
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a{
  text-decoration:none;
  }

.container {
  /* background-color: #cc9090; */
  width: 100vw;
  min-height: 680px;
  min-width: 1250px;
}

.top-add{
  width: 100vw;
  height: 18vw;
  /* min-height: 300px; */
  /* background-color: aqua; */
}

.carouselimg{
  width: 100%;
  height: 100%;

}


.content {
  width: 75vw;
  min-width: 850px;
  /* height: 100vh; */
  /* min-height: 680px; */
  background-color: #f2f6fc;
  box-sizing: border-box;
  margin: auto;
  /* margin-top: 10px; */
  padding-top: 10px;
  display: flex;
  /* box-shadow: 0 5px 25px #888888; */
}

.content-left{
  width: 21%;
  /* height: 800px; */
  /* background-color:yellowgreen; */
}

.el-menu-item{
  height: 2.9vw;
  line-height: 2.9vw;
}

.el-submenu >>> .el-submenu__title {
  height: 2.9vw;
  line-height: 2.9vw;
  }

/* .el-menu-item .el-submenu__title {
  height: 2.9vw !important;
  line-height: 2.9vw !important;
} */

/* .el-submenu {
  height: 2.9vw;
  line-height: 2.9vw;
} */

.menu-show{
  background: #545c64;
}

.menu-show-title {
  font-size: 1vw;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: white;
  display: flex;
  text-align: center;
  /* margin: 10px 0; */
  height: 2.9vw;
  line-height: 2.9vw;
  cursor:pointer;
}

.menu-show-title:hover{
    outline: 0;
    background-color: rgb(67, 74, 80);
}

.menu-addrc{
  width: 100%;
  font-size: 1.05vw;
}


.info-popper-title{
  font-size: 1vw;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: white;
  display: flex;
  /* text-align: center; */
  /* margin: 10px 0; */
  height: 2.9vw;
  line-height: 2.9vw;
  cursor:pointer;
}

.info-show-title {
  font-size: 0.85vw;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: white;
  display: flex;
  text-align: center;
  /* margin: 10px 0; */
  height: 2.9vw;
  line-height: 2.9vw;
  cursor:pointer;
}

.info-show-title:hover{
    outline: 0;
    background-color: rgb(67, 74, 80);
}

.title-addrc{
  width:13.2vw;
  font-size: 0.95vw;
}

.title-addrc3{
    width:13.2vw;
}

.activetext{
        color: #ffd04b;
    }

/* .left-popover{
  margin-left: 0 !important;
  background-color: #959595;
} */




.content-right{
  width: 79%;
  /* height: 800px; */
  /* background-color:aquamarine; */
}

.right-top{
  width: 100%;
  height: 3.15vw;
  /* background-color: burlywood; */
  display: flex;
  align-items: center;
}

.right-breadcrumb{
  width: 60%;
}

.el-breadcrumb {
    font-size: 1vw;
    line-height: 1;
    padding-left: 1vw;
}

.right-search{
 width: 40%;
 padding-left: 12vw;
 padding-right: 3vw;
}

.right-card-list{
  width: 100%;
  margin: auto;
  /* height: 90.5%; */
  padding-bottom: 50px;
  /* background-color:chartreuse; */
  
 
}

.card-list{
  padding: 0;
   margin: auto;
  /* display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: wrap; */
}


.title{
	padding-left: 10px;
	float: left;
}
.more a{
	float: right;
	line-height: 60px;
	color: #000000;
}
.more a:hover{
	color: #ffb217;
}


.phone_item{
	/* display: block; */
  display: inline-block;
	/* float: left; */
	/* width: 230px;
	height: 305px; */
  flex-shrink: 0;
  width: 12.5vw;
  min-width: 165px;
  height: 17.2vw;
	background-color: #FFFFFF;
  margin: 0 0.95vw;
	margin-top: 20px;
}

.goods_item{
  display: flex;
  align-items: center;
	/* float: left; */
	/* width: 230px;
	height: 305px; */
  flex-shrink: 0;
  width: 95%;
  min-width: 165px;
  height: 15.8vw;
	background-color: #FFFFFF;
  margin: 0 0.95vw;
	margin-top: 20px;
}

.goods_title{
  color: #8e96a5;
  margin: auto;
  font-size: 26px;
}

/* 手机配图 */
.ph{
	text-align: center;
	margin: 0.5vw 0;
}

.ph img{
  width: 10vw;
  height: 8.5vw;
}

/* 手机名称 */
.phone_title{
	color: #000000;
	text-align: center;
	font-size: 0.93vw;
	margin-bottom: 0.65vw;
  padding: 0 0.5vw;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* 备注 */
.desc{
	color: #7a7c79;
	text-align: center;
	margin: 0.53vw 0;
  padding: 0 0.5vw;
  font-size: 0.68vw;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* 价格 */
.price{
	color: #ffac38;
	text-align: center;
	margin: 0.5vw 0;
  font-size: 0.84vw;
	font-weight: bold;
  min-height: 1.1vw;
}

.mobile{
  color: #66b1ff;
	text-align: center;
	margin: 0.5vw 0;
  font-size: 0.84vw;
	font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}

.right-pagination{
  text-align: center;
  margin: 0px 25px;
  margin-top: 20px;
  background-color: white;
  border-radius: 5px;
}

</style>



// WEBPACK FOOTER //
// src/components/WebShop.vue